import { render, staticRenderFns } from "./OffMasterSwitch.vue?vue&type=template&id=11bd8e80"
import script from "./OffMasterSwitch.vue?vue&type=script&lang=js"
export * from "./OffMasterSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports